import styled from 'styled-components';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UISelectableButton from 'UIComponents/button/UISelectableButton';
import { jsx as _jsx } from "react/jsx-runtime";
const FeatureSurveySelectableButton = styled(UISelectableButton).withConfig({
  displayName: "FeatureTile__FeatureSurveySelectableButton",
  componentId: "sc-141fa2h-0"
})(["text-align:left !important;width:200px !important;height:80px;padding:4px;span{font-size:14px !important;}"]);
const ButtonContainer = styled.div.withConfig({
  displayName: "FeatureTile__ButtonContainer",
  componentId: "sc-141fa2h-1"
})(["max-width:225px;max-height:125px;"]);
const FeatureTile = ({
  feature,
  onSelectionChange
}) => {
  const {
    featureKey,
    isSelected,
    translationKey
  } = feature;
  return /*#__PURE__*/_jsx(ButtonContainer, {
    children: /*#__PURE__*/_jsx(FeatureSurveySelectableButton, {
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: translationKey
      }),
      selected: isSelected,
      onSelectedChange: evt => onSelectionChange(featureKey, evt.target.value),
      type: "checkbox",
      block: true
    })
  }, featureKey);
};
export default FeatureTile;